import { render, staticRenderFns } from "./News20220701P1.vue?vue&type=template&id=2a2ba1c1&"
import script from "./News20220701P1.vue?vue&type=script&lang=js&"
export * from "./News20220701P1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports